module.exports = __webpack_public_path__ + "static/media/handbags.dfa3a6fd.jpeg";